export default __webpack_public_path__ + "static/media/colgante-estrella-de-david.a7e0d921.png";